module.exports = __webpack_public_path__ + "img/jhPageBg.eef21b7a.png";